import { Redirect, useLocation } from 'react-router-dom';
import { PATH_LOGIN } from '../../Util/constants';

// One-tap login link from the partner emails: /qr?email=<email>&accountId=<accountId reversed>.
// Stores the credentials for the login form (SignIn in Auth.jsx pre-fills from them) and goes
// on to /login. Until 2026-11-04 this page stored them and rendered nothing, so every
// "Open my extranet" button in a partner email landed on a blank page.
const Qr = () => {
	const queryParams = new URLSearchParams(useLocation().search);
	const email = (queryParams.get('email') || '').trim();
	const accountId = (queryParams.get('accountId') || '').trim().split('').reverse().join('');

	// Only store what the link really carries: a missing param must not pre-fill "null".
	if (email && accountId) {
		try {
			localStorage.setItem('partnerLoginEmail', email);
			localStorage.setItem('partnerLoginAccountId', accountId);
		} catch { /* storage blocked: the partner types them in */ }
	}
	return <Redirect to={PATH_LOGIN} />;
};
export default Qr;
